import { DatepickerComponent } from './datepicker/datepicker.component';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { MonthpickerComponent } from './monthpicker/monthpicker.component';
import { YearpickerComponent } from './yearpicker/yearpicker.component';

export const components = [
  DatepickerComponent,
  TimepickerComponent,
  MonthpickerComponent,
  YearpickerComponent
];
